import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { useMotiveTitleStyles } from './styles';
import {
  setTitle,
  setSubtitle,
} from '../../../../redux/slices/BreadcrumbsSlice';

const MotiveTitle = ({ ...props }) => {
  const { title, subtitle, icon, mobile, testId } = props;
  const dispatch = useDispatch();
  const classes = useMotiveTitleStyles({ mobile });

  useEffect(() => {
    dispatch(setTitle(title));
    dispatch(setSubtitle(subtitle));
  }, [title, subtitle]);

  return (
    <React.Fragment>
      <Box className={classes.box} data-testid={testId}>
        <img className={classes.icon} src={icon} alt="icon" />
        <Typography className={classes.title}>{title}</Typography>
      </Box>

      <Typography
        className={classes.subtitle}
        data-testid={testId ? `${testId}-subtitle` : undefined}
      >
        {subtitle}
      </Typography>
    </React.Fragment>
  );
};

MotiveTitle.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  mobile: PropTypes.bool,
  testId: PropTypes.string,
};

export default MotiveTitle;
